import * as React from 'react'
import { createSvgIcon } from '@mui/material/utils'

const Pencil = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9.5 2.79285L11.5 0.792847L15.2071 4.49995L13.2071 6.49995L12.5 7.20706L4.70711 15H1V11.2928L8.79289 3.49995L9.5 2.79285ZM9.5 4.20706L2 11.7071V14H4.29289L11.7929 6.49995L9.5 4.20706ZM12.5 5.79285L10.2071 3.49995L11.5 2.20706L13.7929 4.49995L12.5 5.79285Z"
  />,
  'Pencil'
)

export default Pencil
